import { useFormContext } from "react-hook-form";

import { ConfigFieldsetCard as FieldsetCard } from "src/connections/config/FieldsetCard";
import { InboundWebhookSecretField } from "src/connections/config/inboundWebhook/InboundWebhookSecretField";
import { AuthMethodProps } from "src/connections/config/inboundWebhook/types";
import { isFieldErrored } from "src/connections/config/isFieldErrored";
import { InboundWebhookConnectionConfigInputs } from "src/connections/types";

export const InboundWebhookTruliooHMACHandshakeAuthFieldset: React.FC<
  AuthMethodProps
> = ({ environment }) => {
  const {
    formState: { errors },
  } = useFormContext<InboundWebhookConnectionConfigInputs>();
  const configField = `${environment}Config` as const;

  const settingsErrors =
    errors?.[configField]?.webhookTruliooHMACHandshakeConfig;
  return (
    <FieldsetCard className="last:mb-0">
      <InboundWebhookSecretField
        dataLoc={`${environment}-webhook-hmac-handshake-signing-key`}
        environment={environment}
        helpText="The secret key used to generate the HMAC signature. Ensure it matches the value set in the data provider's system. Depending on the provider, you might need to generate the secret key on your own."
        isErrored={isFieldErrored(settingsErrors?.signingKey, "value")}
        secretConfigField="webhookTruliooHMACHandshakeConfig.signingKey"
        secretName="Signing key"
        isRequired
      />
    </FieldsetCard>
  );
};
